import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaTimes } from "react-icons/fa"; 
import axiosInstance from "config/axiosInstance";


interface Device {
    id: number;
    name: string;
    type: string;
    status: string;
    // Add other relevant fields here
  }
interface AssignedDevicePopupProps {
  onClose: () => void; 
}

const AssignedDevicePopup: React.FC<AssignedDevicePopupProps> = ({ onClose }) => {
    const { id } = useParams<{ id: string }>();
    const [driverName, setDriverName] = useState('Unknown');
    const [assignedDevice, setAssignedDevice] = useState<Device[]>([]);

    const fetchData = useCallback(async () => {
        try {
          const Driverapi = `/v1/devices/?user=${id}`;
          const response = await axiosInstance.get(Driverapi);
          setDriverName(response.data.results[0].user_info?.name);
          setAssignedDevice(response.data.results);
          
        } catch (error) {
          console.error('Failed to fetch driver data', error);
        }
      }, [id]);
    
      useEffect(() => {
        if (id) {
          fetchData();
        }
      }, [id, fetchData]);
      
  return (
    <section className="flex flex-col w-full bg-white rounded-md">
      <div className="flex flex-row items-center justify-between mb-4 border-b">
        <h4 className="text-title p-4">Assigned Devices</h4>
        <button onClick={onClose} className="text-gray-600 hover:text-gray-800 p-4">
          <FaTimes className="h-6 w-6" />
        </button>
      </div>
      <div className="flex flex-row justify-between p-4">
        <div className="flex-1">
            <label className="text-gray-400">DRIVER NAME</label>
            <h6 className="font-semibold">{driverName}</h6>
        </div>
        <div className="flex-1">
            <label className="text-gray-400">ASSIGNED DEVICES</label>
            {assignedDevice.length > 0 ? (
            <ul className="space-y-2">
              {assignedDevice.map((device) => (
                <li key={device.id} className="flex justify-between items-center p-2 rounded-md">
                  <span className="font-medium">{device.id}</span>
                  <span className="text-gray-500">{device.name}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No devices assigned.</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default AssignedDevicePopup;